// 516 스타일 - 지역선택 버튼 + 이름·연락처 폼 / 청록 배경
// 헤더이미지 / 서브이미지 + 지역선택 버튼 / 이름·연락처 폼 / 개인정보 동의 / 제출

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { prohibitedWords } from "../utils/dummyData";

import "./randingStyle31.scss";
import PrivacyContent from "./PrivacyContent";
import { buildPrivacyNewFormHtml } from "./privacyNewForm";
import RandingConsent from "./RandingConsent";

function RandingStyle31({
  urlCode,
  urlCodeSettingId,
  imageFolderPath,
  postBTN,
  companyName,
  apiUrl,
  kakaotalk,
  carrotTag,
  imageExtension = "jpg",
  imageAltTexts,
  themeColor = "#009493",
  areaQuestion = "현재 거주하시는 지역을 선택해주세요.",
  areaOptions = [],
  serviceInfoText,
  privacyCompanyName,
  footerText,
  footerLegalColor,
  privacyDetailContent,
  privacyNewForm,
  privacyTrustee,
}) {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState({
    first: "010",
    second: "",
    third: "",
  });
  const [isAgreed, setIsAgreed] = useState(false);
  const [isMarketingAgreed, setIsMarketingAgreed] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedEventId, setSelectedEventId] = useState(null);

  const validateInput = () =>
    validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber);

  const handleSubmit = () => {
    if (areaOptions.length > 0 && !selectedOption) {
      alert("지역을 선택해주세요.");
      return;
    }
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      selectedValue: selectedEventId || undefined,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,
      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  const getImagePath = (imageNum) =>
    `${imageFolderPath}/${imageNum}.${imageExtension}`;

  const privacyName = privacyCompanyName || companyName || "수집주체명";

  return (
    <div
      className="form-container randing-style-31"
      style={{ "--theme-color": themeColor }}
    >
      {/* 헤더 이미지 */}
      <div className="rs31-images">
        <img
          src={getImagePath("01")}
          alt={imageAltTexts?.header || "헤더 이미지"}
        />

        {/* 청록 배경 섹션 */}
        <div className="rs31-blue-bg">
          {/* 서브 이미지 */}
          <img
            src={getImagePath("02")}
            alt={imageAltTexts?.sub || "서브 이미지"}
          />

          {/* 지역 선택 */}
          {areaOptions.length > 0 && (
            <div className="rs31-area-question-box">
              <div className="rs31-title-box">
                <span>01</span>
                <h3>{areaQuestion}</h3>
              </div>
              <div className="rs31-area-options">
                {areaOptions.map((opt) => (
                  <button
                    key={opt.value}
                    type="button"
                    className={`rs31-option-btn${selectedOption === opt.label ? " active" : ""}`}
                    onClick={() => {
                      setSelectedOption(opt.label);
                      window._selectedOption = opt.label;
                      if (opt.eventId) {
                        // events_option_uuid 전환: uuid 문자열이므로 숫자 변환 금지
                        const eid = opt.eventId;
                        setSelectedEventId(eid);
                        window._selectedEventId = eid;
                      }
                    }}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* 폼 */}
          <form
            className="rs31-dentevent-form"
            id="dentevent-form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <div className="rs31-input-wrap">
              <div className="rs31-input-user">
                <label htmlFor="rs31-name">이름</label>
                <input
                  type="text"
                  id="rs31-name"
                  placeholder="입력*"
                  required
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="rs31-input-contact">
                <label>연락처</label>
                <div className="rs31-phone-wrap">
                  <input
                    type="tel"
                    name="first"
                    maxLength="3"
                    placeholder="010"
                    required
                    readOnly
                    value="010"
                  />
                  <input
                    type="tel"
                    name="second"
                    maxLength="4"
                    placeholder="입력*"
                    required
                    value={phoneNumber.second}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setPhoneNumber((prev) => ({ ...prev, second: value }));
                      if (value.length >= 4) {
                        e.target.nextElementSibling?.focus();
                      }
                    }}
                  />
                  <input
                    type="tel"
                    name="third"
                    maxLength="4"
                    placeholder="입력*"
                    required
                    value={phoneNumber.third}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setPhoneNumber((prev) => ({ ...prev, third: value }));
                    }}
                  />
                </div>
              </div>
            </div>
          </form>

          {/* 개인정보 동의 */}
          <RandingConsent
            isAgreed={isAgreed}
            setIsAgreed={setIsAgreed}
            isMarketingAgreed={isMarketingAgreed}
            setIsMarketingAgreed={setIsMarketingAgreed}
            companyName={privacyName}
            privacyContent={
              privacyDetailContent ||
              (privacyNewForm ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: buildPrivacyNewFormHtml({
                      hospital: privacyName,
                      trustee: privacyTrustee,
                    }),
                  }}
                />
              ) : (
                <PrivacyContent companyName={privacyName} />
              ))
            }
          />

          {/* 서비스 안내 */}
          {serviceInfoText && (
            <div className="rs31-service-info">
              <p>{serviceInfoText}</p>
            </div>
          )}

          {/* 신청하기 버튼 */}
          <button
            type="submit"
            form="dentevent-form"
            className="rs31-btn-apply"
            disabled={isSubmitting}
          >
            <img src={postBTN} alt="신청하기" />
          </button>
        </div>
      </div>

      {/* 푸터 */}
      {footerText && (
        <footer className="rs31-footer">
          {footerLegalColor
            ? footerText.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {i > 0 && "\n"}
                  {/^(Copyright|사업자등록번호)/.test(line) ? (
                    <span style={{ color: footerLegalColor }}>{line}</span>
                  ) : (
                    line
                  )}
                </React.Fragment>
              ))
            : footerText}
        </footer>
      )}
    </div>
  );
}

export default RandingStyle31;
